// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";
import type { Create2dFloodModelInputElevation } from "./Create2dFloodModelInputElevation";
import {
  Create2dFloodModelInputElevationFromJSON,
  Create2dFloodModelInputElevationFromJSONTyped,
  Create2dFloodModelInputElevationToJSON,
  Create2dFloodModelInputElevationToJSONTyped,
} from "./Create2dFloodModelInputElevation";
import type { Create2dFloodModelInputFriction } from "./Create2dFloodModelInputFriction";
import {
  Create2dFloodModelInputFrictionFromJSON,
  Create2dFloodModelInputFrictionFromJSONTyped,
  Create2dFloodModelInputFrictionToJSON,
  Create2dFloodModelInputFrictionToJSONTyped,
} from "./Create2dFloodModelInputFriction";

/**
 *
 * @export
 * @interface Create2dFloodModelInput
 */
export interface Create2dFloodModelInput {
  /**
   *
   */
  friction?: Create2dFloodModelInputFriction | null;
  /**
   *
   */
  elevation: Create2dFloodModelInputElevation;
  /**
   *
   */
  studyArea: RanaFile;
  /**
   *
   */
  infiltration?: Create2dFloodModelInputFriction | null;
  /**
   *
   */
  schematisationName: string;
  /**
   *
   */
  useBoundaryStorageZone?: boolean;
}

/**
 * Check if a given object implements the Create2dFloodModelInput interface.
 */
export function instanceOfCreate2dFloodModelInput(value: object): value is Create2dFloodModelInput {
  if (!("elevation" in value) || value["elevation"] === undefined) return false;
  if (
    (!("studyArea" in (value as Record<string, any>)) &&
      !("study_area" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["studyArea"] === undefined &&
      (value as Record<string, any>)["study_area"] === undefined)
  )
    return false;
  if (
    (!("schematisationName" in (value as Record<string, any>)) &&
      !("schematisation_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["schematisationName"] === undefined &&
      (value as Record<string, any>)["schematisation_name"] === undefined)
  )
    return false;
  return true;
}

export function Create2dFloodModelInputFromJSON(json: any): Create2dFloodModelInput {
  return Create2dFloodModelInputFromJSONTyped(json, false);
}

export function Create2dFloodModelInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Create2dFloodModelInput {
  if (json == null) {
    return json;
  }
  return {
    friction:
      json["friction"] === undefined
        ? undefined
        : json["friction"] === null
        ? null
        : Create2dFloodModelInputFrictionFromJSON(json["friction"]),
    elevation: Create2dFloodModelInputElevationFromJSON(json["elevation"]),
    studyArea: RanaFileFromJSON(json["study_area"]),
    infiltration:
      json["infiltration"] === undefined
        ? undefined
        : json["infiltration"] === null
        ? null
        : Create2dFloodModelInputFrictionFromJSON(json["infiltration"]),
    schematisationName: json["schematisation_name"],
    useBoundaryStorageZone:
      json["use_boundary_storage_zone"] == null ? undefined : json["use_boundary_storage_zone"],
  };
}

export function Create2dFloodModelInputToJSON(json: any): Create2dFloodModelInput {
  return Create2dFloodModelInputToJSONTyped(json, false);
}

export function Create2dFloodModelInputToJSONTyped(
  value?: Create2dFloodModelInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    friction: Create2dFloodModelInputFrictionToJSON(value["friction"]),
    elevation: Create2dFloodModelInputElevationToJSON(value["elevation"]),
    study_area: RanaFileToJSON(value["studyArea"]),
    infiltration: Create2dFloodModelInputFrictionToJSON(value["infiltration"]),
    schematisation_name: value["schematisationName"],
    use_boundary_storage_zone: value["useBoundaryStorageZone"],
  };
}
